/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_launchpad__headline_title = /** @type {(inputs: {}) => string} */ () => {
	return `Auf ViaMichelin finden Sie ...`
};

const en_launchpad__headline_title = /** @type {(inputs: {}) => string} */ () => {
	return `On ViaMichelin, you can find ...`
};

const es_launchpad__headline_title = /** @type {(inputs: {}) => string} */ () => {
	return `En ViaMichelin, puede encontrar ...`
};

const fr_launchpad__headline_title = /** @type {(inputs: {}) => string} */ () => {
	return `Sur ViaMichelin, retrouvez ...`
};

const it_launchpad__headline_title = /** @type {(inputs: {}) => string} */ () => {
	return `Su ViaMichelin puoi trovare ...`
};

const nl_launchpad__headline_title = /** @type {(inputs: {}) => string} */ () => {
	return `Op ViaMichelin vindt u ...`
};

const pt_launchpad__headline_title = /** @type {(inputs: {}) => string} */ () => {
	return `No ViaMichelin, pode encontrar ...`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__headline_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.launchpad__headline_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("launchpad__headline_title", locale)
	if (locale === "de") return de_launchpad__headline_title(inputs)
	if (locale === "en") return en_launchpad__headline_title(inputs)
	if (locale === "es") return es_launchpad__headline_title(inputs)
	if (locale === "fr") return fr_launchpad__headline_title(inputs)
	if (locale === "it") return it_launchpad__headline_title(inputs)
	if (locale === "nl") return nl_launchpad__headline_title(inputs)
	return pt_launchpad__headline_title(inputs)
};